import Settings from '../olr-common/Settings';

export default function AnnouncementService($http) {

  this.saveAnn = function(annObj) {
    let url = Settings.backendEnv + "/api/v1/announcement";
    var req = {
      method:  "POST",
      url:    url,
      data:   annObj
    };

    return $http(req);
  };

  this.getAllAnns = function(){
  	let url = Settings.backendEnv + "/api/v1/teacher/announcements";
    return $http({method: 'GET',url: url});
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/AnnouncementService.js
 **/